/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * エラーコード
 */
export type ErrorResponseErrorCode =
  (typeof ErrorResponseErrorCode)[keyof typeof ErrorResponseErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorResponseErrorCode = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  BUSINESS_LOGIC_ERROR: 'BUSINESS_LOGIC_ERROR',
  INTEGRITY_ERROR: 'INTEGRITY_ERROR',
  UNIQUE_CONSTRAINT_ERROR: 'UNIQUE_CONSTRAINT_ERROR',
  FOREIGN_KEY_CONSTRAINT_ERROR: 'FOREIGN_KEY_CONSTRAINT_ERROR',
  PROTECTED_FOREIGN_KEY_ERROR: 'PROTECTED_FOREIGN_KEY_ERROR',
  NOT_NULL_CONSTRAINT_ERROR: 'NOT_NULL_CONSTRAINT_ERROR',
  CHECK_CONSTRAINT_ERROR: 'CHECK_CONSTRAINT_ERROR',
  SUSPICIOUS_OPERATION: 'SUSPICIOUS_OPERATION',
  HTTP_ERROR: 'HTTP_ERROR',
  GUARDDUTY_SCAN_ERROR: 'GUARDDUTY_SCAN_ERROR',
  AUTHENTICATION_ERROR: 'AUTHENTICATION_ERROR',
  PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
  AUTHORIZATION_ERROR: 'AUTHORIZATION_ERROR',
  TOKEN_LIMIT_EXCEEDED: 'TOKEN_LIMIT_EXCEEDED',
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  NOT_FOUND: 'NOT_FOUND',
  OBJECT_NOT_FOUND: 'OBJECT_NOT_FOUND',
  GUARDDUTY_IN_PROGRESS: 'GUARDDUTY_IN_PROGRESS',
  DATABASE_ERROR: 'DATABASE_ERROR',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  EXTERNAL_SERVICE_ERROR: 'EXTERNAL_SERVICE_ERROR',
  EXTERNAL_SERVICE_UNAVAILABLE: 'EXTERNAL_SERVICE_UNAVAILABLE',
} as const;
